import { toastConfig } from 'lib/reactToastify/config';
import { useState } from 'react';
import { toast } from 'react-toastify';

import { logError } from 'lib/sentry/logError';

import { useChatMessagesContext } from 'features/chat/context/chatMessages';
import { scrollToBottom } from 'features/chat/utils';

import { Button } from 'shared/components/Button';

type TChatScrollToMessageProps = {
  children: React.ReactNode;
  messageId: string;
};

export const ChatScrollToMessage = ({
  children,
  messageId,
}: TChatScrollToMessageProps) => {
  const [disabled, setDisabled] = useState(false);
  const { fetchNextPage, messages, chatRef } = useChatMessagesContext();

  const messageNode = document.getElementById(messageId);

  const scrollToMessage = async () => {
    messageNode?.scrollIntoView({ behavior: 'smooth' });
  };

  const fetchAndScrollToMessage = async () => {
    try {
      !disabled &&
        (await fetchNextPage({
          pageParam: {
            fromMessageId: messages[0].messageId,
            direction: 'up',
            // similar to mobile logic we search in the first 150 messages
            // 150 - 20 (initial messages) = 130 (next page limit)
            limit: 130,
          },
        }));

      const messageNode = document.getElementById(messageId);

      if (messageNode) {
        messageNode.scrollIntoView({ behavior: 'smooth' });
        return;
      }

      scrollToBottom(chatRef?.current);
      setDisabled(true);
    } catch (error) {
      toast.error(
        "There's an error with reading messages. Please try again later.",
        {
          icon: false,
          ...toastConfig,
        }
      );
      logError(error);
    }
  };

  return (
    <Button
      style={{
        paddingLeft: '0',
        justifyContent: 'start',
      }}
      onClick={messageNode ? scrollToMessage : fetchAndScrollToMessage}
      size="xs"
      variant="ghost"
    >
      {children}
    </Button>
  );
};
